<ng-container *ngIf="isValid; else noData">
	<div class="padding-bottom-8 title-icon">
		<span class="text-uppercase text-18-bold">{{ portfolioWiseTab[0].config.title.label.translated }}</span>
		<icon
			type="info-circle"
			class="info-circle"
			[tooltip-dcr]="portfolioWiseTab[0].config.title.label.key + '_TOOLTIP'"
			[analytic-data]="{ linkName: portfolioWiseTab[0].config.title.label.key + '_TOOLTIP' }"
		></icon>
	</div>

	<div [dcrHTMLKey]="portfolioWiseTab[0].config.title.label.key + '_SUBTITLE'" class="margin-bottom-24 text-16">
		Identify the holdings driving the ESG Rating of your portfolio and find opportunities to take action to potentially improve the overall sustainability of your portfolio.
		The range and average of ESG Ratings vary widely across region and peer groups; consider comparing funds within similar asset classes.
	</div>
	<bfa-portfolio-selector
		[portfolioData]="data.portfolioData"
		[selectedPortfolioIndex]="selectedPortfolioIndex"
		(updateSelectedPortfolioIndex)="selectedPortfolioIndex = $event"
		[useMaxLength]="true"
		[maxLength]="75"
		selectorType="tabs"
	></bfa-portfolio-selector>
	<div class="margin-top-20">
		<esg-holding-rankings-table
			[data]="data"
			[tabs]="portfolioWiseTab"
			[tableIndex]="selectedPortfolioIndex"
			[singlePortColumnProportions]="singlePortColumnProportions"
			[multiPortColumnProportions]="multiPortColumnProportions"
		></esg-holding-rankings-table>
	</div>
	<ac-disclosure textClass="text-condensed-14 padding-top-16" [isExpandable]="false" [dcrKey]="disclosureKey"></ac-disclosure>
	<ac-disclosure [isExpandable]="false" *ngIf="showAsOfDateDynamic && asOfDate">
		<span dcrHTMLKey="AS_OF_DATE_DYNAMIC" [dcrSubstitutions]="{ asOfDate: asOfDate }">As of asOfDate</span>
	</ac-disclosure>
</ng-container>

<ng-template #noData>
	<dl-no-data *ngIf="shouldShowNoDataComponent" [data]="data"></dl-no-data>
</ng-template>
